export default {
  handleDocumentContainer: {
    title: 'Attach an estimate',
    text: 'Present us with a quote from a craftsman of your choice. This will be reviewed by our technical team who will validate it or contact you if necessary.',
    actions: {
      primary: 'Continue'
    },
    documentUploadStep: {
      actions: {
        primary: 'Attach the document'
      }
    },
    icrModal: {
      title: 'Uploading files',
      text1: 'The files are currently being processed. Please continue to wait.',
      text2: 'The process may take a few minutes.',
      text3: 'We are processing your documents. In a few minutes we will validate your compensation.'
    }
  }
}
